/**
 * @desc 解冻
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockOrderUnfreezeCmd, options?: any) {
  return updateResponse(
    http(URL + `/stock/unfreeze`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
